import React from "react";
import { Loader2 } from "lucide-react";

export function LoadingSplash() {
  return (
    <div className="fixed inset-0 min-h-screen w-full bg-background flex flex-col items-center justify-center z-50 animate-fade-in">
      {/* Central Logo */}
      <img
        src="/app-icon.png"
        alt="Office Rhythm"
        className="w-16 h-16 sm:w-20 sm:h-20 drop-shadow-sm mb-8"
        onError={(e) => {
          // Fallback if the logo fails to load (e.g., local dev missing asset)
          e.currentTarget.style.display = 'none';
        }}
      />
      
      {/* Subtle imperceptbile loading indicator */}
      <div className="flex flex-col items-center gap-2">
        <Loader2 className="h-4 w-4 text-muted-foreground/30 animate-spin" />
        <span className="text-[10px] uppercase tracking-[0.2em] font-medium text-muted-foreground/40">
          Loading Module
        </span>
      </div>
    </div>
  );
}
